"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTableProperty = exports.tablePropertyDefinition = void 0;
exports.tablePropertyDefinition = {
    view: { label: 'Table' },
    constraints: [],
    type: 'table',
    multiple: false,
    name: 'table',
};
const isTableProperty = (prop) => {
    return prop.name === exports.tablePropertyDefinition.name;
};
exports.isTableProperty = isTableProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFibGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90YWJsZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLE9BQU87Q0FDa0IsQ0FBQTtBQXFCMUIsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFrQixFQUF5QixFQUFFO0lBQzNFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQkFBdUIsQ0FBQyxJQUFJLENBQUE7QUFDbkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxlQUFlLG1CQUUzQiJ9